import { render, staticRenderFns } from "./writeOffIndex.vue?vue&type=template&id=1bfd7949&scoped=true&"
import script from "./writeOffIndex.vue?vue&type=script&lang=js&"
export * from "./writeOffIndex.vue?vue&type=script&lang=js&"
import style0 from "./writeOffIndex.vue?vue&type=style&index=0&id=1bfd7949&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd7949",
  null
  
)

export default component.exports